<!-- useless now -->
<template>
  <div>
    <el-card class="cardDiv">
      <div slot="header">
        <span>风控通知</span>
      </div>
      <div class="topDiv">
        <span class="notRead">{{ '未读通知[' + notReadNum + ']' }}</span>
        <div class="rightDiv">
          <el-button type="default" size="small" @click="readAll">查看全部通知</el-button>
          <el-button type="primary" size="small" @click="clearNotRead">清空未读</el-button>
        </div>
      </div>
      <el-table :show-header="false" :data="noticeList" class="table" v-if="noticeList.length>0">
        <el-table-column prop="details">
          <template slot-scope="scope">
            <p class="noticeTitle" @click="toDetails(scope.row)">商户{{ scope.row.fMerchantName }}&nbsp;&nbsp;的风控审核
              <span v-if="scope.row.auditStatus == 1">待提交</span>
              <span v-if="scope.row.auditStatus == 2">正在审核中</span>
              <span v-if="scope.row.auditStatus == 3">审核未通过</span>
              <span v-if="scope.row.auditStatus == 4">审核通过</span>
              <span v-if="scope.row.auditStatus == 5">审核终止</span>
              <span v-if="scope.row.auditStatus == 6">待提交</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="fCreateTime" width="160">
        </el-table-column>
      </el-table>
      <el-row v-else class="noneText">暂无未读通知，<span class="allLink" @click="readAll">查看全部通知</span></el-row>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import { riskOperFlows, updateReadState } from '@/api/home'
import { parseAuditStatus } from '@/utils/parseData'
export default {
  name: 'NotReadNotice',
  data () {
    return {
      noticeNum: 100,
      noticeList: [
        // {
        //     details:'商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。',
        //     time:'2019-01-01 20:20'
        // },
        // {
        //     details:'商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。',
        //     time:'2019-01-01 20:20'
        // },
        // {
        //     details:'商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。商户 张某某  存在风险，风险来源：微信违规，请及时提交申诉材料。',
        //     time:'2019-01-01 20:20'
        // },
      ],
      loading: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    notReadNum () {
      if (this.noticeNum <= 99) {
        return this.noticeNum
      } else {
        return '99+'
      }
    }
  },
  methods: {
    getList () {
      var data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        FReadStatus: 0
      }
      data = qs.stringify(data)
      riskOperFlows(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.noticeList = data.data.list.map(item => {
            item.auditStatus = parseAuditStatus(item.fTicketStatus, item.fMtlVerifyStatus)
            return item
          })
          this.noticeNum = data.data.totalCount
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '请求数据超时，请稍后重试',
          type: 'error'
        })
      })
    },
    /**
             * @description 查看全部消息
             */
    readAll () {
      this.$router.push('/index/allNotice')
    },
    /**
             * @description 查看消息详情
             */
    toDetails (row) {
      var data = {
        flowId: row.fId
      }
      data = qs.stringify(data)
      updateReadState(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {

        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '请求数据超时，请稍后重试',
          type: 'error'
        })
      })
      this.$router.push('/Risk/RiskManage/checkDetails/' + row.fTicketNumber)
    },
    /**
             * @description 清空未读消息
             */
    clearNotRead () {
      this.$confirm('确定清空全部未读通知吗？（清空后仍可在全部通知中查看）', '提示', {}).then(() => {
        var data = {
          emptyMyMsg: 1
        }
        data = qs.stringify(data)
        updateReadState(data).then(data => {
          if (parseInt(data.error_code) !== 0) {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'success'
            })
            this.getList()
          }
        })
      })
    }
  }
}
</script>

<style scoped>
    .cardDiv{
        min-height: 200px;
    }
    .noticeTitle{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: underline;
        cursor: pointer;
        margin: 0;
    }
    .table{
        border: 1px solid #ebeef5;
    }
    .notRead{
        border: 1px solid #ebeef5;
        background: #f4f4f5;
        color: #606266;
        line-height: 40px;
        height: 40px;
        font-size: 14px;
        padding: 0 10px;
        float: left;
    }
    .rightDiv{
        float: right;
    }
    .allLink{
        color:#409EFF;
        text-decoration: underline;
        cursor: pointer;
    }
    .topDiv:after{
        clear: both;
        content: '';
        overflow: hidden;
        height: 0;
        display: block;
        visibility: hidden;
    }
    .noneText{
        margin-top: 50px;
        text-align: center;
        color:#606266;
        font-size: 14px;
    }
</style>
